module.exports = __webpack_public_path__ + "img/poster-injection-hydrocortisone.689c0b2e.png";